import { lazy } from 'react';

export const DealListLazy = lazy(() => import('@/pages/loan/deal/DealList'));
export const LoanDealCreateLazy = lazy(
  () => import('@/pages/loan/deal/LoanDealCreate'),
);
export const InterestReceivedFormLazy = lazy(
  () => import('@/pages/loan/interestReceived/InterestReceivedForm'),
);
export const InterestReceivedListLazy = lazy(
  () => import('@/pages/loan/interestReceived/InterestReceivedList'),
);
export const BankIssueFormLazy = lazy(
  () => import('@/pages/loan/issueToBank/BankIssueForm'),
);
export const BankIssueListLazy = lazy(
  () => import('@/pages/loan/issueToBank/BankIssueList'),
);
export const PartyLoanListLazy = lazy(() => import('@/pages/loan/LoanList'));
export const PartyLoanDetailsLazy = lazy(
  () => import('@/pages/loan/PartyLoanDetails'),
);
export const BankReceivesListLazy = lazy(
  () => import('@/pages/loan/receiveFromBank/BankReceivesList'),
);
